// Module
var code = `<div class="js-tercera-checkbox-container" style="{{>visibility}}">
    <div class="js-checkbox"
         ischecked="{{.checked?'1':'0'}}"
         checkBoxCheckedState="{{.checkBoxCheckedState}}"
         on-click="@this.private_CheckBoxClick(this)"
         on-mousedown="@this.onMouseDown(event)"
         as-tooltip="tooltip"
         {{>visualparameters}}>

        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#checkBox"></use>
        </svg>
    </div>

    {{#if .text}}
    <div class="js-tercera-label" on-click="@this.private_CheckBoxClick(this)" on-mousedown="@this.onMouseDown(event)" {{^.enabled}}disabled="" {{/}}
         as-tooltip="tooltip">{{.text}}</div>
    {{/if}}
</div>`;
// Exports
export default code;